import React, { useEffect, useState } from "react";
import './intro.css';
import { Link } from "react-scroll";
import EmailUs from '../../assets/EmailUs.png';
import bg from '../../assets/TopManRugbyLogo.jpg';
import axiosInstance from "../../api/axiosInstance";  // ✅ FIXED IMPORT PATH
import ThreeApps from '../../assets/AboutUs.jpg';
import '../AboutUs/aboutUs.css';
import '../News/news.css';
import LikeButton from "../LikeButton"; // adjust path if needed

const Intro = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    fetchPosts();
  }, []);

  const fetchPosts = async () => {
    try {
      const res = await axiosInstance.get("/posts");  
      setPosts(res.data);
    } catch (err) {
      console.error("Error fetching posts:", err);
    }
  };

  return (
    <div>
      {/* Intro Section */}
      <section id="intro">
        <div className="bgContainer">
          <img src={bg} alt="Background" className="bg" />
        </div>

        <div className="introContent">
          <span className="hello">Hello,</span> <br/>
          <span className="introText">
            Welcome to the<span className="introName">TopMan</span> 
            <br /> Charity Website
          </span>
          <p className="introPara">
            In the high mountains of Southeast Asia, where rugby was neither defined as a sport for most nor widely understood, three brothers found inspiration in an expat rugby club. They spent hours watching balls being flung across the field, captivated by the game. Eventually, a team was formed for them to play on, and the eldest of the brothers quickly stood out. Known as "TopMan," he made an impression from the moment he first set foot on the pitch.
            <br /><br />
            It was immediately clear that TopMan was something special. He had a natural talent for the game, with lightning-fast reflexes and a famed "goose step" that made him almost impossible to tackle. But it wasn’t just his physical abilities that set him apart. TopMan possessed fierce determination, a deep love for the sport, and—most significantly—a profound appreciation for the big smiles of the kids he played along with.
          </p>
          <Link to="contact" smooth={true} duration={500}>
  <button className="btn">
    <img src={EmailUs} alt="Learn more" className="btnImg" />
    Learn more
  </button>
</Link>
        </div>
      </section>

      {/* About Us Section */}
      <section id="aboutUs">
        <h1 className="aboutTitle">What we do</h1>
        <div className="aboutBars">
          <div className="aboutBar">
            <img src={ThreeApps} alt="Our mission" className="aboutBarImg" />
            <div className="aboutBarText">
              <h2>Our passion is to make rugby accessible globally to everyone</h2>
            </div>
          </div>
        </div>
      </section>

      {/* News Section */}
      <section id="news">
        <h2 className="newsTitle">Recent Rugby News</h2>
        {posts.map((post) => (
  <div key={post.id} className="newsItem">
    <h3>{post.title}</h3>
    <p>{post.content}</p>
    {post.media_url && (
      post.media_url.endsWith(".mp4") ? (
        <video controls src={`http://localhost:5000${post.media_url}`} className="newsMedia" />
      ) : (
        <img src={`http://localhost:5000${post.media_url}`} alt="Post media" className="newsMedia" />
      )
    )}

    {/* ✅ Add Like Button HERE */}
    <LikeButton postId={post.id} />
  </div>
))}

      </section>
    </div>
  );
};

export default Intro;
